import React from 'react';
import CreatableSelect from 'react-select/creatable';

import makeAnimated from 'react-select/animated';
import classNames from './style.module.scss';

import { CoverDataItem } from '../../../utils/models';
import { MultiValue, SingleValue } from 'react-select/dist/declarations/src';

interface MultiselectDropdownProps {
    closeMenuOnSelect: boolean;
	options: CoverDataItem[];
    isMulti: boolean;
	label: string;
    isSearchable: boolean;
    defaultValue?: CoverDataItem[];
	onSelect: (selectedItem: MultiValue<CoverDataItem> | SingleValue<CoverDataItem>) => void;
	placeholder: string;
	error?: string;
	isLoading: boolean;
	selectedValues: CoverDataItem[] | CoverDataItem;
    onCreateOption?: (value: string) => void;
}

const CreatableMultiselectDropdown: React.FC<MultiselectDropdownProps>= ({closeMenuOnSelect, defaultValue, error, options, isMulti, label, isLoading, isSearchable, onSelect, onCreateOption, placeholder, selectedValues }) => {
    return (
        <div className={classNames['form-input-group']}>
			{label && (<label className={classNames['form-input-group-label']}>{label}:</label>)}

            <CreatableSelect 
                onChange={onSelect}
                closeMenuOnSelect={closeMenuOnSelect}
                defaultValue={defaultValue}
                value={selectedValues}
                components={makeAnimated()}
                backspaceRemovesValue={false}
                minMenuHeight={900}
                isMulti={isMulti} 
                options={options} 
                aria-label={label} 
                isSearchable={isSearchable}
                placeholder={placeholder}
                isLoading={isLoading}
                classNamePrefix='createable-select'
				className={classNames['form-input-group-field']}
                onCreateOption={onCreateOption}
                styles={{
                    control: (baseStyles, state) => ({...baseStyles, boxShadow: state.isFocused ? '0 0 0 1px #235681' : '0', }),
                    menuList: (baseStyles) => ({ ...baseStyles, maxHeight: 500 }),
                  }}
            />
            
            {error && <div className="error">{error}</div>}
		</div>
    );
}
 
export default CreatableMultiselectDropdown;